import {
	Id,
	LaravelResponse,
	PaginatedListFetcherConfig,
	keyToUrl,
	mapPaginatedFetcherConfigToAxiosConfig,
	withDestroyEndpoint,
	withIndexEndpoint,
	withOptionsEndpoint,
	withShowEndpoint,
	withStoreEndpoint,
	withUpdateEndpoint,
} from "@dgs/core";
import axios from "axios";
import {
	IContactIndexResource,
	IDistributionListContactRequest,
	IDistributionListIndexResource,
	IDistributionListOption,
	IDistributionListRequest,
	IDistributionListUpdateResource,
} from "../types";

const baseKey = "distribution-lists";

const keys = {
	index: [baseKey],
	list: [baseKey, "list"],
	options: [baseKey, "options"],
	details: (id: Id) => [baseKey, `${id}`],
	indexContacts: (id: Id) => [baseKey, `${id}`, "contacts"],
	syncContacts: (id: Id) => [baseKey, `${id}`, "sync-contacts"],
	attachContacts: (id: Id) => [baseKey, `${id}`, "attach-contacts"],
	detachContacts: (id: Id) => [baseKey, `${id}`, "detach-contacts"],
};

const urls = {
	index: keyToUrl(keys.index),
	details: (id: Id) => keyToUrl(keys.details(id)),
	options: keyToUrl(keys.options),
	indexContacts: (id: Id) => keyToUrl(keys.indexContacts(id)),
	syncContacts: (id: Id) => keyToUrl(keys.syncContacts(id)),
	attachContacts: (id: Id) => keyToUrl(keys.attachContacts(id)),
	detachContacts: (id: Id) => keyToUrl(keys.detachContacts(id)),
};

const indexContacts =
	(id: Id, contactViewId: Id | null) => (config: PaginatedListFetcherConfig<IContactIndexResource>) =>
		axios.get<LaravelResponse<IContactIndexResource[]>>(urls.indexContacts(id), {
			params: { ...mapPaginatedFetcherConfigToAxiosConfig(config).params, contactViewId },
		});

const syncContacts = (id: Id, contactRequest: IDistributionListContactRequest) =>
	axios.put(urls.syncContacts(id), contactRequest);

const attachContacts = (
	id: Id,
	contactRequest: IDistributionListContactRequest,
	params: { contactFilterId: Id | null; search?: string },
) => axios.put(urls.attachContacts(id), { ...contactRequest, ...params });

const detachContacts = (id: Id, contactRequest: IDistributionListContactRequest) =>
	axios.put(urls.detachContacts(id), contactRequest);

export const distributionListService = {
	indexContacts,
	indexContactsKey: keys.indexContacts,
	syncContacts,
	syncContactsKey: keys.syncContacts,
	attachContacts,
	attachContactsKey: keys.attachContacts,
	detachContacts,
	detachContactsKey: keys.detachContacts,
	...withShowEndpoint<IDistributionListUpdateResource>([baseKey]),
	...withIndexEndpoint<IDistributionListIndexResource>([baseKey]),
	...withOptionsEndpoint<IDistributionListOption>([baseKey]),
	...withDestroyEndpoint([baseKey]),
	...withUpdateEndpoint<IDistributionListRequest>([baseKey]),
	...withStoreEndpoint<IDistributionListRequest>([baseKey]),
};
